import type { LogLevel } from '../types'
import { state } from '../state'

/**
 * Log a message.
 * @param logLevel - The log level.
 * @param message - The message to log.
 * @param context - The context of the log.
 */
export async function log(logLevel: LogLevel, message: string, context?: Record<string, string>): Promise<void> {
  await state.eventBus.dispatchLog({
    level: logLevel,
    message,
    context,
  })
}
